import React from "react";
import "./Test.css";

export default function Test() {
  // 👉 Số điện thoại nhận tin nhắn
  const phone = "0763823860";

  // 👉 Nội dung tin nhắn mặc định
  const message = "Chào shop, tôi muốn tư vấn dịch vụ rút tiền thẻ tín dụng.";

  // 👉 Encode nội dung để tránh lỗi ký tự
  const encodedMessage = encodeURIComponent(message);

  // 👉 Link mở app nhắn tin SMS
  const smsLink = `sms:${phone}?body=${encodedMessage}`;

  return (
    <div className="message-cta">
      <a href={smsLink} className="message-btn">
        💬 Nhắn tin ngay
      </a>
    </div>
  );
}
